/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MRouteImport } from './routes/m'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as MIndexRouteImport } from './routes/m.index'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as MPrestacaoRouteImport } from './routes/m.prestacao'
import { Route as MMasterRouteImport } from './routes/m.master'
import { Route as MLancamentosRouteImport } from './routes/m.lancamentos'
import { Route as MEuRouteImport } from './routes/m.eu'
import { Route as AppUsuariosRouteImport } from './routes/_app.usuarios'
import { Route as AppPrestacoesRouteImport } from './routes/_app.prestacoes'
import { Route as AppMasterRouteImport } from './routes/_app.master'
import { Route as AppLancamentosRouteImport } from './routes/_app.lancamentos'
import { Route as AppDocumentosRouteImport } from './routes/_app.documentos'
import { Route as AppConfiguracoesRouteImport } from './routes/_app.configuracoes'
import { Route as AppConciliacaoRouteImport } from './routes/_app.conciliacao'
import { Route as MMasterIndexRouteImport } from './routes/m.master.index'
import { Route as AppMasterIndexRouteImport } from './routes/_app.master.index'
import { Route as AppLancamentosIndexRouteImport } from './routes/_app.lancamentos.index'
import { Route as MMasterWorkspacesRouteImport } from './routes/m.master.workspaces'
import { Route as MMasterConfigRouteImport } from './routes/m.master.config'
import { Route as MMasterCobrancasRouteImport } from './routes/m.master.cobrancas'
import { Route as MMasterAuditoriaRouteImport } from './routes/m.master.auditoria'
import { Route as AppPrestacoesPreviewRouteImport } from './routes/_app.prestacoes.preview'
import { Route as AppPrestacoesOcrCaptureRouteImport } from './routes/_app.prestacoes.ocr-capture'
import { Route as AppPrestacaoLiveIdRouteImport } from './routes/_app.prestacao-live.$id'
import { Route as AppMasterWorkspacesRouteImport } from './routes/_app.master.workspaces'
import { Route as AppMasterBillingRouteImport } from './routes/_app.master.billing'
import { Route as AppLancamentosTransparenciaRouteImport } from './routes/_app.lancamentos.transparencia'
import { Route as AppLancamentosReceitasRouteImport } from './routes/_app.lancamentos.receitas'
import { Route as AppLancamentosPublicacoesRouteImport } from './routes/_app.lancamentos.publicacoes'
import { Route as AppLancamentosPagamentosRouteImport } from './routes/_app.lancamentos.pagamentos'
import { Route as AppLancamentosEmpregadosRouteImport } from './routes/_app.lancamentos.empregados'
import { Route as AppLancamentosDocumentosFiscaisRouteImport } from './routes/_app.lancamentos.documentos-fiscais'
import { Route as AppLancamentosDisponibilidadesRouteImport } from './routes/_app.lancamentos.disponibilidades'
import { Route as AppLancamentosDevolucoesRouteImport } from './routes/_app.lancamentos.devolucoes'
import { Route as AppLancamentosDemonstracoesRouteImport } from './routes/_app.lancamentos.demonstracoes'
import { Route as AppLancamentosDeclaracoesRouteImport } from './routes/_app.lancamentos.declaracoes'
import { Route as AppLancamentosContratosRouteImport } from './routes/_app.lancamentos.contratos'
import { Route as AppLancamentosBensRouteImport } from './routes/_app.lancamentos.bens'
import { Route as AppLancamentosAtividadesRouteImport } from './routes/_app.lancamentos.atividades'
import { Route as AppLancamentosAjustesRouteImport } from './routes/_app.lancamentos.ajustes'
import { Route as MMasterWorkspacesIndexRouteImport } from './routes/m.master.workspaces.index'
import { Route as MMasterWorkspacesIdRouteImport } from './routes/m.master.workspaces.$id'

const MRoute = MRouteImport.update({
  id: '/m',
  path: '/m',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const MIndexRoute = MIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const MPrestacaoRoute = MPrestacaoRouteImport.update({
  id: '/prestacao',
  path: '/prestacao',
  getParentRoute: () => MRoute,
} as any)
const MMasterRoute = MMasterRouteImport.update({
  id: '/master',
  path: '/master',
  getParentRoute: () => MRoute,
} as any)
const MLancamentosRoute = MLancamentosRouteImport.update({
  id: '/lancamentos',
  path: '/lancamentos',
  getParentRoute: () => MRoute,
} as any)
const MEuRoute = MEuRouteImport.update({
  id: '/eu',
  path: '/eu',
  getParentRoute: () => MRoute,
} as any)
const AppUsuariosRoute = AppUsuariosRouteImport.update({
  id: '/usuarios',
  path: '/usuarios',
  getParentRoute: () => AppRoute,
} as any)
const AppPrestacoesRoute = AppPrestacoesRouteImport.update({
  id: '/prestacoes',
  path: '/prestacoes',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterRoute = AppMasterRouteImport.update({
  id: '/master',
  path: '/master',
  getParentRoute: () => AppRoute,
} as any)
const AppLancamentosRoute = AppLancamentosRouteImport.update({
  id: '/lancamentos',
  path: '/lancamentos',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentosRoute = AppDocumentosRouteImport.update({
  id: '/documentos',
  path: '/documentos',
  getParentRoute: () => AppRoute,
} as any)
const AppConfiguracoesRoute = AppConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => AppRoute,
} as any)
const AppConciliacaoRoute = AppConciliacaoRouteImport.update({
  id: '/conciliacao',
  path: '/conciliacao',
  getParentRoute: () => AppRoute,
} as any)
const MMasterIndexRoute = MMasterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MMasterRoute,
} as any)
const AppMasterIndexRoute = AppMasterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMasterRoute,
} as any)
const AppLancamentosIndexRoute = AppLancamentosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLancamentosRoute,
} as any)
const MMasterWorkspacesRoute = MMasterWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => MMasterRoute,
} as any)
const MMasterConfigRoute = MMasterConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => MMasterRoute,
} as any)
const MMasterCobrancasRoute = MMasterCobrancasRouteImport.update({
  id: '/cobrancas',
  path: '/cobrancas',
  getParentRoute: () => MMasterRoute,
} as any)
const MMasterAuditoriaRoute = MMasterAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => MMasterRoute,
} as any)
const AppPrestacoesPreviewRoute = AppPrestacoesPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => AppPrestacoesRoute,
} as any)
const AppPrestacoesOcrCaptureRoute = AppPrestacoesOcrCaptureRouteImport.update({
  id: '/ocr-capture',
  path: '/ocr-capture',
  getParentRoute: () => AppPrestacoesRoute,
} as any)
const AppPrestacaoLiveIdRoute = AppPrestacaoLiveIdRouteImport.update({
  id: '/prestacao-live/$id',
  path: '/prestacao-live/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterWorkspacesRoute = AppMasterWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AppMasterRoute,
} as any)
const AppMasterBillingRoute = AppMasterBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppMasterRoute,
} as any)
const AppLancamentosTransparenciaRoute =
  AppLancamentosTransparenciaRouteImport.update({
    id: '/transparencia',
    path: '/transparencia',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosReceitasRoute = AppLancamentosReceitasRouteImport.update({
  id: '/receitas',
  path: '/receitas',
  getParentRoute: () => AppLancamentosRoute,
} as any)
const AppLancamentosPublicacoesRoute =
  AppLancamentosPublicacoesRouteImport.update({
    id: '/publicacoes',
    path: '/publicacoes',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosPagamentosRoute =
  AppLancamentosPagamentosRouteImport.update({
    id: '/pagamentos',
    path: '/pagamentos',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosEmpregadosRoute =
  AppLancamentosEmpregadosRouteImport.update({
    id: '/empregados',
    path: '/empregados',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosDocumentosFiscaisRoute =
  AppLancamentosDocumentosFiscaisRouteImport.update({
    id: '/documentos-fiscais',
    path: '/documentos-fiscais',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosDisponibilidadesRoute =
  AppLancamentosDisponibilidadesRouteImport.update({
    id: '/disponibilidades',
    path: '/disponibilidades',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosDevolucoesRoute =
  AppLancamentosDevolucoesRouteImport.update({
    id: '/devolucoes',
    path: '/devolucoes',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosDemonstracoesRoute =
  AppLancamentosDemonstracoesRouteImport.update({
    id: '/demonstracoes',
    path: '/demonstracoes',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosDeclaracoesRoute =
  AppLancamentosDeclaracoesRouteImport.update({
    id: '/declaracoes',
    path: '/declaracoes',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosContratosRoute = AppLancamentosContratosRouteImport.update({
  id: '/contratos',
  path: '/contratos',
  getParentRoute: () => AppLancamentosRoute,
} as any)
const AppLancamentosBensRoute = AppLancamentosBensRouteImport.update({
  id: '/bens',
  path: '/bens',
  getParentRoute: () => AppLancamentosRoute,
} as any)
const AppLancamentosAtividadesRoute =
  AppLancamentosAtividadesRouteImport.update({
    id: '/atividades',
    path: '/atividades',
    getParentRoute: () => AppLancamentosRoute,
  } as any)
const AppLancamentosAjustesRoute = AppLancamentosAjustesRouteImport.update({
  id: '/ajustes',
  path: '/ajustes',
  getParentRoute: () => AppLancamentosRoute,
} as any)
const MMasterWorkspacesIndexRoute = MMasterWorkspacesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MMasterWorkspacesRoute,
} as any)
const MMasterWorkspacesIdRoute = MMasterWorkspacesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => MMasterWorkspacesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/m': typeof MRouteWithChildren
  '/conciliacao': typeof AppConciliacaoRoute
  '/configuracoes': typeof AppConfiguracoesRoute
  '/documentos': typeof AppDocumentosRoute
  '/lancamentos': typeof AppLancamentosRouteWithChildren
  '/master': typeof AppMasterRouteWithChildren
  '/prestacoes': typeof AppPrestacoesRouteWithChildren
  '/usuarios': typeof AppUsuariosRoute
  '/m/eu': typeof MEuRoute
  '/m/lancamentos': typeof MLancamentosRoute
  '/m/master': typeof MMasterRouteWithChildren
  '/m/prestacao': typeof MPrestacaoRoute
  '/m/': typeof MIndexRoute
  '/lancamentos/ajustes': typeof AppLancamentosAjustesRoute
  '/lancamentos/atividades': typeof AppLancamentosAtividadesRoute
  '/lancamentos/bens': typeof AppLancamentosBensRoute
  '/lancamentos/contratos': typeof AppLancamentosContratosRoute
  '/lancamentos/declaracoes': typeof AppLancamentosDeclaracoesRoute
  '/lancamentos/demonstracoes': typeof AppLancamentosDemonstracoesRoute
  '/lancamentos/devolucoes': typeof AppLancamentosDevolucoesRoute
  '/lancamentos/disponibilidades': typeof AppLancamentosDisponibilidadesRoute
  '/lancamentos/documentos-fiscais': typeof AppLancamentosDocumentosFiscaisRoute
  '/lancamentos/empregados': typeof AppLancamentosEmpregadosRoute
  '/lancamentos/pagamentos': typeof AppLancamentosPagamentosRoute
  '/lancamentos/publicacoes': typeof AppLancamentosPublicacoesRoute
  '/lancamentos/receitas': typeof AppLancamentosReceitasRoute
  '/lancamentos/transparencia': typeof AppLancamentosTransparenciaRoute
  '/master/billing': typeof AppMasterBillingRoute
  '/master/workspaces': typeof AppMasterWorkspacesRoute
  '/prestacao-live/$id': typeof AppPrestacaoLiveIdRoute
  '/prestacoes/ocr-capture': typeof AppPrestacoesOcrCaptureRoute
  '/prestacoes/preview': typeof AppPrestacoesPreviewRoute
  '/m/master/auditoria': typeof MMasterAuditoriaRoute
  '/m/master/cobrancas': typeof MMasterCobrancasRoute
  '/m/master/config': typeof MMasterConfigRoute
  '/m/master/workspaces': typeof MMasterWorkspacesRouteWithChildren
  '/lancamentos/': typeof AppLancamentosIndexRoute
  '/master/': typeof AppMasterIndexRoute
  '/m/master/': typeof MMasterIndexRoute
  '/m/master/workspaces/$id': typeof MMasterWorkspacesIdRoute
  '/m/master/workspaces/': typeof MMasterWorkspacesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/conciliacao': typeof AppConciliacaoRoute
  '/configuracoes': typeof AppConfiguracoesRoute
  '/documentos': typeof AppDocumentosRoute
  '/prestacoes': typeof AppPrestacoesRouteWithChildren
  '/usuarios': typeof AppUsuariosRoute
  '/m/eu': typeof MEuRoute
  '/m/lancamentos': typeof MLancamentosRoute
  '/m/prestacao': typeof MPrestacaoRoute
  '/': typeof AppIndexRoute
  '/m': typeof MIndexRoute
  '/lancamentos/ajustes': typeof AppLancamentosAjustesRoute
  '/lancamentos/atividades': typeof AppLancamentosAtividadesRoute
  '/lancamentos/bens': typeof AppLancamentosBensRoute
  '/lancamentos/contratos': typeof AppLancamentosContratosRoute
  '/lancamentos/declaracoes': typeof AppLancamentosDeclaracoesRoute
  '/lancamentos/demonstracoes': typeof AppLancamentosDemonstracoesRoute
  '/lancamentos/devolucoes': typeof AppLancamentosDevolucoesRoute
  '/lancamentos/disponibilidades': typeof AppLancamentosDisponibilidadesRoute
  '/lancamentos/documentos-fiscais': typeof AppLancamentosDocumentosFiscaisRoute
  '/lancamentos/empregados': typeof AppLancamentosEmpregadosRoute
  '/lancamentos/pagamentos': typeof AppLancamentosPagamentosRoute
  '/lancamentos/publicacoes': typeof AppLancamentosPublicacoesRoute
  '/lancamentos/receitas': typeof AppLancamentosReceitasRoute
  '/lancamentos/transparencia': typeof AppLancamentosTransparenciaRoute
  '/master/billing': typeof AppMasterBillingRoute
  '/master/workspaces': typeof AppMasterWorkspacesRoute
  '/prestacao-live/$id': typeof AppPrestacaoLiveIdRoute
  '/prestacoes/ocr-capture': typeof AppPrestacoesOcrCaptureRoute
  '/prestacoes/preview': typeof AppPrestacoesPreviewRoute
  '/m/master/auditoria': typeof MMasterAuditoriaRoute
  '/m/master/cobrancas': typeof MMasterCobrancasRoute
  '/m/master/config': typeof MMasterConfigRoute
  '/lancamentos': typeof AppLancamentosIndexRoute
  '/master': typeof AppMasterIndexRoute
  '/m/master': typeof MMasterIndexRoute
  '/m/master/workspaces/$id': typeof MMasterWorkspacesIdRoute
  '/m/master/workspaces': typeof MMasterWorkspacesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/m': typeof MRouteWithChildren
  '/_app/conciliacao': typeof AppConciliacaoRoute
  '/_app/configuracoes': typeof AppConfiguracoesRoute
  '/_app/documentos': typeof AppDocumentosRoute
  '/_app/lancamentos': typeof AppLancamentosRouteWithChildren
  '/_app/master': typeof AppMasterRouteWithChildren
  '/_app/prestacoes': typeof AppPrestacoesRouteWithChildren
  '/_app/usuarios': typeof AppUsuariosRoute
  '/m/eu': typeof MEuRoute
  '/m/lancamentos': typeof MLancamentosRoute
  '/m/master': typeof MMasterRouteWithChildren
  '/m/prestacao': typeof MPrestacaoRoute
  '/_app/': typeof AppIndexRoute
  '/m/': typeof MIndexRoute
  '/_app/lancamentos/ajustes': typeof AppLancamentosAjustesRoute
  '/_app/lancamentos/atividades': typeof AppLancamentosAtividadesRoute
  '/_app/lancamentos/bens': typeof AppLancamentosBensRoute
  '/_app/lancamentos/contratos': typeof AppLancamentosContratosRoute
  '/_app/lancamentos/declaracoes': typeof AppLancamentosDeclaracoesRoute
  '/_app/lancamentos/demonstracoes': typeof AppLancamentosDemonstracoesRoute
  '/_app/lancamentos/devolucoes': typeof AppLancamentosDevolucoesRoute
  '/_app/lancamentos/disponibilidades': typeof AppLancamentosDisponibilidadesRoute
  '/_app/lancamentos/documentos-fiscais': typeof AppLancamentosDocumentosFiscaisRoute
  '/_app/lancamentos/empregados': typeof AppLancamentosEmpregadosRoute
  '/_app/lancamentos/pagamentos': typeof AppLancamentosPagamentosRoute
  '/_app/lancamentos/publicacoes': typeof AppLancamentosPublicacoesRoute
  '/_app/lancamentos/receitas': typeof AppLancamentosReceitasRoute
  '/_app/lancamentos/transparencia': typeof AppLancamentosTransparenciaRoute
  '/_app/master/billing': typeof AppMasterBillingRoute
  '/_app/master/workspaces': typeof AppMasterWorkspacesRoute
  '/_app/prestacao-live/$id': typeof AppPrestacaoLiveIdRoute
  '/_app/prestacoes/ocr-capture': typeof AppPrestacoesOcrCaptureRoute
  '/_app/prestacoes/preview': typeof AppPrestacoesPreviewRoute
  '/m/master/auditoria': typeof MMasterAuditoriaRoute
  '/m/master/cobrancas': typeof MMasterCobrancasRoute
  '/m/master/config': typeof MMasterConfigRoute
  '/m/master/workspaces': typeof MMasterWorkspacesRouteWithChildren
  '/_app/lancamentos/': typeof AppLancamentosIndexRoute
  '/_app/master/': typeof AppMasterIndexRoute
  '/m/master/': typeof MMasterIndexRoute
  '/m/master/workspaces/$id': typeof MMasterWorkspacesIdRoute
  '/m/master/workspaces/': typeof MMasterWorkspacesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/m'
    | '/conciliacao'
    | '/configuracoes'
    | '/documentos'
    | '/lancamentos'
    | '/master'
    | '/prestacoes'
    | '/usuarios'
    | '/m/eu'
    | '/m/lancamentos'
    | '/m/master'
    | '/m/prestacao'
    | '/m/'
    | '/lancamentos/ajustes'
    | '/lancamentos/atividades'
    | '/lancamentos/bens'
    | '/lancamentos/contratos'
    | '/lancamentos/declaracoes'
    | '/lancamentos/demonstracoes'
    | '/lancamentos/devolucoes'
    | '/lancamentos/disponibilidades'
    | '/lancamentos/documentos-fiscais'
    | '/lancamentos/empregados'
    | '/lancamentos/pagamentos'
    | '/lancamentos/publicacoes'
    | '/lancamentos/receitas'
    | '/lancamentos/transparencia'
    | '/master/billing'
    | '/master/workspaces'
    | '/prestacao-live/$id'
    | '/prestacoes/ocr-capture'
    | '/prestacoes/preview'
    | '/m/master/auditoria'
    | '/m/master/cobrancas'
    | '/m/master/config'
    | '/m/master/workspaces'
    | '/lancamentos/'
    | '/master/'
    | '/m/master/'
    | '/m/master/workspaces/$id'
    | '/m/master/workspaces/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/conciliacao'
    | '/configuracoes'
    | '/documentos'
    | '/prestacoes'
    | '/usuarios'
    | '/m/eu'
    | '/m/lancamentos'
    | '/m/prestacao'
    | '/'
    | '/m'
    | '/lancamentos/ajustes'
    | '/lancamentos/atividades'
    | '/lancamentos/bens'
    | '/lancamentos/contratos'
    | '/lancamentos/declaracoes'
    | '/lancamentos/demonstracoes'
    | '/lancamentos/devolucoes'
    | '/lancamentos/disponibilidades'
    | '/lancamentos/documentos-fiscais'
    | '/lancamentos/empregados'
    | '/lancamentos/pagamentos'
    | '/lancamentos/publicacoes'
    | '/lancamentos/receitas'
    | '/lancamentos/transparencia'
    | '/master/billing'
    | '/master/workspaces'
    | '/prestacao-live/$id'
    | '/prestacoes/ocr-capture'
    | '/prestacoes/preview'
    | '/m/master/auditoria'
    | '/m/master/cobrancas'
    | '/m/master/config'
    | '/lancamentos'
    | '/master'
    | '/m/master'
    | '/m/master/workspaces/$id'
    | '/m/master/workspaces'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/m'
    | '/_app/conciliacao'
    | '/_app/configuracoes'
    | '/_app/documentos'
    | '/_app/lancamentos'
    | '/_app/master'
    | '/_app/prestacoes'
    | '/_app/usuarios'
    | '/m/eu'
    | '/m/lancamentos'
    | '/m/master'
    | '/m/prestacao'
    | '/_app/'
    | '/m/'
    | '/_app/lancamentos/ajustes'
    | '/_app/lancamentos/atividades'
    | '/_app/lancamentos/bens'
    | '/_app/lancamentos/contratos'
    | '/_app/lancamentos/declaracoes'
    | '/_app/lancamentos/demonstracoes'
    | '/_app/lancamentos/devolucoes'
    | '/_app/lancamentos/disponibilidades'
    | '/_app/lancamentos/documentos-fiscais'
    | '/_app/lancamentos/empregados'
    | '/_app/lancamentos/pagamentos'
    | '/_app/lancamentos/publicacoes'
    | '/_app/lancamentos/receitas'
    | '/_app/lancamentos/transparencia'
    | '/_app/master/billing'
    | '/_app/master/workspaces'
    | '/_app/prestacao-live/$id'
    | '/_app/prestacoes/ocr-capture'
    | '/_app/prestacoes/preview'
    | '/m/master/auditoria'
    | '/m/master/cobrancas'
    | '/m/master/config'
    | '/m/master/workspaces'
    | '/_app/lancamentos/'
    | '/_app/master/'
    | '/m/master/'
    | '/m/master/workspaces/$id'
    | '/m/master/workspaces/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  MRoute: typeof MRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/m': {
      id: '/m'
      path: '/m'
      fullPath: '/m'
      preLoaderRoute: typeof MRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/m/': {
      id: '/m/'
      path: '/'
      fullPath: '/m/'
      preLoaderRoute: typeof MIndexRouteImport
      parentRoute: typeof MRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/m/prestacao': {
      id: '/m/prestacao'
      path: '/prestacao'
      fullPath: '/m/prestacao'
      preLoaderRoute: typeof MPrestacaoRouteImport
      parentRoute: typeof MRoute
    }
    '/m/master': {
      id: '/m/master'
      path: '/master'
      fullPath: '/m/master'
      preLoaderRoute: typeof MMasterRouteImport
      parentRoute: typeof MRoute
    }
    '/m/lancamentos': {
      id: '/m/lancamentos'
      path: '/lancamentos'
      fullPath: '/m/lancamentos'
      preLoaderRoute: typeof MLancamentosRouteImport
      parentRoute: typeof MRoute
    }
    '/m/eu': {
      id: '/m/eu'
      path: '/eu'
      fullPath: '/m/eu'
      preLoaderRoute: typeof MEuRouteImport
      parentRoute: typeof MRoute
    }
    '/_app/usuarios': {
      id: '/_app/usuarios'
      path: '/usuarios'
      fullPath: '/usuarios'
      preLoaderRoute: typeof AppUsuariosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/prestacoes': {
      id: '/_app/prestacoes'
      path: '/prestacoes'
      fullPath: '/prestacoes'
      preLoaderRoute: typeof AppPrestacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master': {
      id: '/_app/master'
      path: '/master'
      fullPath: '/master'
      preLoaderRoute: typeof AppMasterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lancamentos': {
      id: '/_app/lancamentos'
      path: '/lancamentos'
      fullPath: '/lancamentos'
      preLoaderRoute: typeof AppLancamentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documentos': {
      id: '/_app/documentos'
      path: '/documentos'
      fullPath: '/documentos'
      preLoaderRoute: typeof AppDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/configuracoes': {
      id: '/_app/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof AppConfiguracoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conciliacao': {
      id: '/_app/conciliacao'
      path: '/conciliacao'
      fullPath: '/conciliacao'
      preLoaderRoute: typeof AppConciliacaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/m/master/': {
      id: '/m/master/'
      path: '/'
      fullPath: '/m/master/'
      preLoaderRoute: typeof MMasterIndexRouteImport
      parentRoute: typeof MMasterRoute
    }
    '/_app/master/': {
      id: '/_app/master/'
      path: '/'
      fullPath: '/master/'
      preLoaderRoute: typeof AppMasterIndexRouteImport
      parentRoute: typeof AppMasterRoute
    }
    '/_app/lancamentos/': {
      id: '/_app/lancamentos/'
      path: '/'
      fullPath: '/lancamentos/'
      preLoaderRoute: typeof AppLancamentosIndexRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/m/master/workspaces': {
      id: '/m/master/workspaces'
      path: '/workspaces'
      fullPath: '/m/master/workspaces'
      preLoaderRoute: typeof MMasterWorkspacesRouteImport
      parentRoute: typeof MMasterRoute
    }
    '/m/master/config': {
      id: '/m/master/config'
      path: '/config'
      fullPath: '/m/master/config'
      preLoaderRoute: typeof MMasterConfigRouteImport
      parentRoute: typeof MMasterRoute
    }
    '/m/master/cobrancas': {
      id: '/m/master/cobrancas'
      path: '/cobrancas'
      fullPath: '/m/master/cobrancas'
      preLoaderRoute: typeof MMasterCobrancasRouteImport
      parentRoute: typeof MMasterRoute
    }
    '/m/master/auditoria': {
      id: '/m/master/auditoria'
      path: '/auditoria'
      fullPath: '/m/master/auditoria'
      preLoaderRoute: typeof MMasterAuditoriaRouteImport
      parentRoute: typeof MMasterRoute
    }
    '/_app/prestacoes/preview': {
      id: '/_app/prestacoes/preview'
      path: '/preview'
      fullPath: '/prestacoes/preview'
      preLoaderRoute: typeof AppPrestacoesPreviewRouteImport
      parentRoute: typeof AppPrestacoesRoute
    }
    '/_app/prestacoes/ocr-capture': {
      id: '/_app/prestacoes/ocr-capture'
      path: '/ocr-capture'
      fullPath: '/prestacoes/ocr-capture'
      preLoaderRoute: typeof AppPrestacoesOcrCaptureRouteImport
      parentRoute: typeof AppPrestacoesRoute
    }
    '/_app/prestacao-live/$id': {
      id: '/_app/prestacao-live/$id'
      path: '/prestacao-live/$id'
      fullPath: '/prestacao-live/$id'
      preLoaderRoute: typeof AppPrestacaoLiveIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master/workspaces': {
      id: '/_app/master/workspaces'
      path: '/workspaces'
      fullPath: '/master/workspaces'
      preLoaderRoute: typeof AppMasterWorkspacesRouteImport
      parentRoute: typeof AppMasterRoute
    }
    '/_app/master/billing': {
      id: '/_app/master/billing'
      path: '/billing'
      fullPath: '/master/billing'
      preLoaderRoute: typeof AppMasterBillingRouteImport
      parentRoute: typeof AppMasterRoute
    }
    '/_app/lancamentos/transparencia': {
      id: '/_app/lancamentos/transparencia'
      path: '/transparencia'
      fullPath: '/lancamentos/transparencia'
      preLoaderRoute: typeof AppLancamentosTransparenciaRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/receitas': {
      id: '/_app/lancamentos/receitas'
      path: '/receitas'
      fullPath: '/lancamentos/receitas'
      preLoaderRoute: typeof AppLancamentosReceitasRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/publicacoes': {
      id: '/_app/lancamentos/publicacoes'
      path: '/publicacoes'
      fullPath: '/lancamentos/publicacoes'
      preLoaderRoute: typeof AppLancamentosPublicacoesRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/pagamentos': {
      id: '/_app/lancamentos/pagamentos'
      path: '/pagamentos'
      fullPath: '/lancamentos/pagamentos'
      preLoaderRoute: typeof AppLancamentosPagamentosRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/empregados': {
      id: '/_app/lancamentos/empregados'
      path: '/empregados'
      fullPath: '/lancamentos/empregados'
      preLoaderRoute: typeof AppLancamentosEmpregadosRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/documentos-fiscais': {
      id: '/_app/lancamentos/documentos-fiscais'
      path: '/documentos-fiscais'
      fullPath: '/lancamentos/documentos-fiscais'
      preLoaderRoute: typeof AppLancamentosDocumentosFiscaisRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/disponibilidades': {
      id: '/_app/lancamentos/disponibilidades'
      path: '/disponibilidades'
      fullPath: '/lancamentos/disponibilidades'
      preLoaderRoute: typeof AppLancamentosDisponibilidadesRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/devolucoes': {
      id: '/_app/lancamentos/devolucoes'
      path: '/devolucoes'
      fullPath: '/lancamentos/devolucoes'
      preLoaderRoute: typeof AppLancamentosDevolucoesRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/demonstracoes': {
      id: '/_app/lancamentos/demonstracoes'
      path: '/demonstracoes'
      fullPath: '/lancamentos/demonstracoes'
      preLoaderRoute: typeof AppLancamentosDemonstracoesRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/declaracoes': {
      id: '/_app/lancamentos/declaracoes'
      path: '/declaracoes'
      fullPath: '/lancamentos/declaracoes'
      preLoaderRoute: typeof AppLancamentosDeclaracoesRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/contratos': {
      id: '/_app/lancamentos/contratos'
      path: '/contratos'
      fullPath: '/lancamentos/contratos'
      preLoaderRoute: typeof AppLancamentosContratosRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/bens': {
      id: '/_app/lancamentos/bens'
      path: '/bens'
      fullPath: '/lancamentos/bens'
      preLoaderRoute: typeof AppLancamentosBensRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/atividades': {
      id: '/_app/lancamentos/atividades'
      path: '/atividades'
      fullPath: '/lancamentos/atividades'
      preLoaderRoute: typeof AppLancamentosAtividadesRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/_app/lancamentos/ajustes': {
      id: '/_app/lancamentos/ajustes'
      path: '/ajustes'
      fullPath: '/lancamentos/ajustes'
      preLoaderRoute: typeof AppLancamentosAjustesRouteImport
      parentRoute: typeof AppLancamentosRoute
    }
    '/m/master/workspaces/': {
      id: '/m/master/workspaces/'
      path: '/'
      fullPath: '/m/master/workspaces/'
      preLoaderRoute: typeof MMasterWorkspacesIndexRouteImport
      parentRoute: typeof MMasterWorkspacesRoute
    }
    '/m/master/workspaces/$id': {
      id: '/m/master/workspaces/$id'
      path: '/$id'
      fullPath: '/m/master/workspaces/$id'
      preLoaderRoute: typeof MMasterWorkspacesIdRouteImport
      parentRoute: typeof MMasterWorkspacesRoute
    }
  }
}

interface AppLancamentosRouteChildren {
  AppLancamentosAjustesRoute: typeof AppLancamentosAjustesRoute
  AppLancamentosAtividadesRoute: typeof AppLancamentosAtividadesRoute
  AppLancamentosBensRoute: typeof AppLancamentosBensRoute
  AppLancamentosContratosRoute: typeof AppLancamentosContratosRoute
  AppLancamentosDeclaracoesRoute: typeof AppLancamentosDeclaracoesRoute
  AppLancamentosDemonstracoesRoute: typeof AppLancamentosDemonstracoesRoute
  AppLancamentosDevolucoesRoute: typeof AppLancamentosDevolucoesRoute
  AppLancamentosDisponibilidadesRoute: typeof AppLancamentosDisponibilidadesRoute
  AppLancamentosDocumentosFiscaisRoute: typeof AppLancamentosDocumentosFiscaisRoute
  AppLancamentosEmpregadosRoute: typeof AppLancamentosEmpregadosRoute
  AppLancamentosPagamentosRoute: typeof AppLancamentosPagamentosRoute
  AppLancamentosPublicacoesRoute: typeof AppLancamentosPublicacoesRoute
  AppLancamentosReceitasRoute: typeof AppLancamentosReceitasRoute
  AppLancamentosTransparenciaRoute: typeof AppLancamentosTransparenciaRoute
  AppLancamentosIndexRoute: typeof AppLancamentosIndexRoute
}

const AppLancamentosRouteChildren: AppLancamentosRouteChildren = {
  AppLancamentosAjustesRoute: AppLancamentosAjustesRoute,
  AppLancamentosAtividadesRoute: AppLancamentosAtividadesRoute,
  AppLancamentosBensRoute: AppLancamentosBensRoute,
  AppLancamentosContratosRoute: AppLancamentosContratosRoute,
  AppLancamentosDeclaracoesRoute: AppLancamentosDeclaracoesRoute,
  AppLancamentosDemonstracoesRoute: AppLancamentosDemonstracoesRoute,
  AppLancamentosDevolucoesRoute: AppLancamentosDevolucoesRoute,
  AppLancamentosDisponibilidadesRoute: AppLancamentosDisponibilidadesRoute,
  AppLancamentosDocumentosFiscaisRoute: AppLancamentosDocumentosFiscaisRoute,
  AppLancamentosEmpregadosRoute: AppLancamentosEmpregadosRoute,
  AppLancamentosPagamentosRoute: AppLancamentosPagamentosRoute,
  AppLancamentosPublicacoesRoute: AppLancamentosPublicacoesRoute,
  AppLancamentosReceitasRoute: AppLancamentosReceitasRoute,
  AppLancamentosTransparenciaRoute: AppLancamentosTransparenciaRoute,
  AppLancamentosIndexRoute: AppLancamentosIndexRoute,
}

const AppLancamentosRouteWithChildren = AppLancamentosRoute._addFileChildren(
  AppLancamentosRouteChildren,
)

interface AppMasterRouteChildren {
  AppMasterBillingRoute: typeof AppMasterBillingRoute
  AppMasterWorkspacesRoute: typeof AppMasterWorkspacesRoute
  AppMasterIndexRoute: typeof AppMasterIndexRoute
}

const AppMasterRouteChildren: AppMasterRouteChildren = {
  AppMasterBillingRoute: AppMasterBillingRoute,
  AppMasterWorkspacesRoute: AppMasterWorkspacesRoute,
  AppMasterIndexRoute: AppMasterIndexRoute,
}

const AppMasterRouteWithChildren = AppMasterRoute._addFileChildren(
  AppMasterRouteChildren,
)

interface AppPrestacoesRouteChildren {
  AppPrestacoesOcrCaptureRoute: typeof AppPrestacoesOcrCaptureRoute
  AppPrestacoesPreviewRoute: typeof AppPrestacoesPreviewRoute
}

const AppPrestacoesRouteChildren: AppPrestacoesRouteChildren = {
  AppPrestacoesOcrCaptureRoute: AppPrestacoesOcrCaptureRoute,
  AppPrestacoesPreviewRoute: AppPrestacoesPreviewRoute,
}

const AppPrestacoesRouteWithChildren = AppPrestacoesRoute._addFileChildren(
  AppPrestacoesRouteChildren,
)

interface AppRouteChildren {
  AppConciliacaoRoute: typeof AppConciliacaoRoute
  AppConfiguracoesRoute: typeof AppConfiguracoesRoute
  AppDocumentosRoute: typeof AppDocumentosRoute
  AppLancamentosRoute: typeof AppLancamentosRouteWithChildren
  AppMasterRoute: typeof AppMasterRouteWithChildren
  AppPrestacoesRoute: typeof AppPrestacoesRouteWithChildren
  AppUsuariosRoute: typeof AppUsuariosRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPrestacaoLiveIdRoute: typeof AppPrestacaoLiveIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppConciliacaoRoute: AppConciliacaoRoute,
  AppConfiguracoesRoute: AppConfiguracoesRoute,
  AppDocumentosRoute: AppDocumentosRoute,
  AppLancamentosRoute: AppLancamentosRouteWithChildren,
  AppMasterRoute: AppMasterRouteWithChildren,
  AppPrestacoesRoute: AppPrestacoesRouteWithChildren,
  AppUsuariosRoute: AppUsuariosRoute,
  AppIndexRoute: AppIndexRoute,
  AppPrestacaoLiveIdRoute: AppPrestacaoLiveIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface MMasterWorkspacesRouteChildren {
  MMasterWorkspacesIdRoute: typeof MMasterWorkspacesIdRoute
  MMasterWorkspacesIndexRoute: typeof MMasterWorkspacesIndexRoute
}

const MMasterWorkspacesRouteChildren: MMasterWorkspacesRouteChildren = {
  MMasterWorkspacesIdRoute: MMasterWorkspacesIdRoute,
  MMasterWorkspacesIndexRoute: MMasterWorkspacesIndexRoute,
}

const MMasterWorkspacesRouteWithChildren =
  MMasterWorkspacesRoute._addFileChildren(MMasterWorkspacesRouteChildren)

interface MMasterRouteChildren {
  MMasterAuditoriaRoute: typeof MMasterAuditoriaRoute
  MMasterCobrancasRoute: typeof MMasterCobrancasRoute
  MMasterConfigRoute: typeof MMasterConfigRoute
  MMasterWorkspacesRoute: typeof MMasterWorkspacesRouteWithChildren
  MMasterIndexRoute: typeof MMasterIndexRoute
}

const MMasterRouteChildren: MMasterRouteChildren = {
  MMasterAuditoriaRoute: MMasterAuditoriaRoute,
  MMasterCobrancasRoute: MMasterCobrancasRoute,
  MMasterConfigRoute: MMasterConfigRoute,
  MMasterWorkspacesRoute: MMasterWorkspacesRouteWithChildren,
  MMasterIndexRoute: MMasterIndexRoute,
}

const MMasterRouteWithChildren =
  MMasterRoute._addFileChildren(MMasterRouteChildren)

interface MRouteChildren {
  MEuRoute: typeof MEuRoute
  MLancamentosRoute: typeof MLancamentosRoute
  MMasterRoute: typeof MMasterRouteWithChildren
  MPrestacaoRoute: typeof MPrestacaoRoute
  MIndexRoute: typeof MIndexRoute
}

const MRouteChildren: MRouteChildren = {
  MEuRoute: MEuRoute,
  MLancamentosRoute: MLancamentosRoute,
  MMasterRoute: MMasterRouteWithChildren,
  MPrestacaoRoute: MPrestacaoRoute,
  MIndexRoute: MIndexRoute,
}

const MRouteWithChildren = MRoute._addFileChildren(MRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  MRoute: MRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
